(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
	var Tabby = require('tabbyjs');

	if (document.querySelector('[data-tabs]')) {
		var tabs = new Tabby('[data-tabs]');

		tabs.setup();
	}
})();